import { UPDATE_SCREEN_SIZE } from '../constants';

const updateScreenSize = screenSize => ({
  type: UPDATE_SCREEN_SIZE,
  screenSize,
});

export default updateScreenSize;



// WEBPACK FOOTER //
// ./src/redux/actions/updateScreenSize.js